<template>
	<Scroller ref="mainScroller" :main="true" :class="`scroller`">
		<Page slug="404" name="404" :metadata="page?.metadata">
			<Error />
		</Page>
	</Scroller>

	<PreLoader :title="`${SITE_NAME} — ${SITE_DESCRIPTION}`" color="#201914" />
</template>

<script setup>
import { Error } from '~/components/pages'
import { Scroller, Page, PreLoader } from '~/components/core'

import { SITE_NAME, SITE_DESCRIPTION } from './config/site'

const mainScroller = ref(null)

const page = {
	metadata: {
		description: 'Gold. Owned, Allocated, On-Chain',
		image: null,
		keywords: null,
		lang: 'en',
		path: '/',
		sitedescription: 'Gold. Owned, Allocated, On-Chain',
		sitename: 'AUM',
		title: '404',
		unlisted: false,
	},
}

provide('$scroller', mainScroller)

useHead({
	bodyAttrs: {
		class: 'page-404',
	},
})
</script>

<style lang="scss" scoped>
._page[data-slug='404'],
._page[data-name='404'] {
	._common-header {
		h1 {
			white-space: pre;
		}

		._scroll-hint {
			display: none;
		}
	}
}
</style>
